import { Sandpack } from "@codesandbox/sandpack-react";

export default function Others() {
  const code = `import React from 'react';
import { ReactUtilityTable } from 'react-utility-table';

export default function App() {
  const [mockData] = React.useState([
    { first_name: "John", last_name: "Cena", email: "JohnCena@gmail.com" },
    { first_name: "Randy", last_name: "Orton", email: "RandyOrton@gmail.com" },
    { first_name: "Roman", last_name: "Reign", email: "RomanReign@gmail.com" },
  ]);

  const [showData, setShowData] = React.useState(false);

  const columns = [
    { title: "Name", field: "first_name" },
    { title: "Last Name", field: "last_name", filtering: false },
    { title: "Email", field: "email" },
  ];

  const options = {
    toolbar: false,
    pageSize: 10,
    maxBodyHeight: "15rem",
    minBodyHeight: "10rem",
    allBorder: true,
  };

  const handleRowClick = (evt, rowClick) => {
    console.log(rowClick, "rowClicked");
  };

  const emptyMessage = (
    <div onClick={() => setShowData(true)} style={{ cursor: "pointer" }}>
      <span style={{ color: "blue" }}>Click</span> here to view Data
    </div>
  );

  return (
    <div>
      <ReactUtilityTable
        data={showData ? mockData : []}
        columns={columns}
        options={options}
        emptyDataMessage={emptyMessage}
        onRowClick={handleRowClick}
      />
    </div>
  );
}
`;

  return (
    <>
      <p style={{ margin: "5px 0px" }}>
        <strong>PlayGround for editable: </strong>
        <br />
        <br />
      </p>
      <Sandpack
        template="react"
        files={{
          "/App.js": code,
        }}
        customSetup={{
          dependencies: {
            react: "18.0.0",
            "react-dom": "18.0.0",
            "react-scripts": "5.0.1",
            "react-utility-table": "2.1.5",
          },
        }}
        theme="dark"
        options={{
          showLineNumbers: true,
          editorHeight: 500,
        }}
      />
    </>
  );
}

